// extracted by mini-css-extract-plugin
module.exports = {"itemWrap":"PriorityItem_itemWrap__3bkNC","priority":"PriorityItem_priority__2-sUT"};